var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showOverlay && !_vm.dismissed
    ? _c(
        "v-overlay",
        {
          staticClass: "status-overlay",
          class: _vm.statusClass,
          attrs: { value: true, opacity: "0", "z-index": "9999" },
        },
        [
          _c(
            "div",
            { staticClass: "overlay-content" },
            [
              _c(
                "div",
                {
                  staticClass: "status-icon-container",
                  class: _vm.statusClass,
                },
                [
                  _c("v-icon", { attrs: { size: "64", color: "white" } }, [
                    _vm._v(_vm._s(_vm.statusIcon)),
                  ]),
                ],
                1
              ),
              _c("h1", { staticClass: "overlay-title" }, [
                _vm._v(" " + _vm._s(_vm.title) + " "),
              ]),
              _vm.status.bannerText
                ? _c("p", { staticClass: "overlay-message" }, [
                    _vm._v(" " + _vm._s(_vm.status.bannerText) + " "),
                  ])
                : _vm._e(),
              _vm.status.maintenanceRemaining
                ? _c(
                    "div",
                    { staticClass: "countdown-container" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "white" } },
                        [_vm._v("mdi-clock-outline")]
                      ),
                      _c("span", { staticClass: "countdown-text" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("estimated-time-remaining")) +
                            ": " +
                            _vm._s(_vm.status.maintenanceRemaining) +
                            " " +
                            _vm._s(_vm.$t("minutes")) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-progress-linear", {
                staticClass: "progress-bar",
                attrs: {
                  indeterminate: "",
                  rounded: "",
                  height: "6",
                  color: "white",
                },
              }),
              _c("p", { staticClass: "overlay-hint" }, [
                _vm._v(" " + _vm._s(_vm.$t("overlay-wait-message")) + " "),
              ]),
              _vm.isDevops
                ? _c(
                    "v-btn",
                    {
                      staticClass: "devops-dismiss-btn mt-4",
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.dismissed = true
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-shield-account"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("devops-bypass")) + " "),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }